import request from "@/plugins/axios"
//发票板式文件审核
let prefix = "eids-invoice/invStat";

// 获取增值税发票olap数据
export function olap(queryParam) {
  return request({
    url: prefix + '/vatOlap',
    method: 'post',
    data: queryParam
  })
}



